<template>
  <div class="services">
    <div class="card">
      <h2 class="card-header bg-primary text-white text-uppercase">Orders</h2>
      <div class="card-body">
        <button type="button" class="btn btn-secondary" @click="sendJob()">
          Clock
        </button>

        <div class="mx-auto" v-if="!services.length">No data available</div>
        <div class="row">
          <div class="col-md-4" v-for="service in services" :key="service._id">
            <div class="card mb-4">
              <div class="card-header bg-primary text-white text-uppercase">
                {{ service.service_type.service_name }}
              </div>
              <div class="card-body">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item">
                    <span class="font-weight-bold">Make</span> :
                    <span>{{ service["car"]["make"] }}</span>
                  </li>
                  <li class="list-group-item">
                    <span class="font-weight-bold">Trim</span> :
                    <span>{{ service["car"]["trim"] }}</span>
                  </li>
                  <li class="list-group-item">
                    <span class="font-weight-bold">Model</span> :
                    <span>{{ service["car"]["model"] }}</span>
                  </li>
                  <li class="list-group-item">
                    <span class="font-weight-bold">Posted by</span> :
                    <span
                      class="text-primary"
                      style="cursor: pointer"
                      data-toggle="modal"
                      data-target="#userInfo"
                      @click="setUserInfo(service['car']['user_id'])"
                      >{{ service["car"]["user_id"]["firstname"] }}
                      {{ service["car"]["user_id"]["lastname"] }}</span
                    >
                  </li>
                  <li class="list-group-item">
                    <span class="font-weight-bold">Description</span> :
                    <p>{{ service["details"] }}</p>
                  </li>
                  <li class="list-group-item">
                    <span class="font-weight-bold">Price</span> :
                    <span>{{
                      service["price"]
                        ? formatPrice(service["price"])
                        : "Not Set"
                    }}</span>
                  </li>
                  <li class="list-group-item">
                    <span class="font-weight-bold">For</span> :
                    <span>{{ service.date }} - {{ service.time }}</span>
                  </li>
                </ul>
                <!-- Button trigger modal price -->
                <div class="row mt-4">
                  <div class="col-md-12">
                    <button
                      type="button"
                      class="btn btn-primary btn-sm btn-block waves-effect"
                      data-toggle="modal"
                      data-target="#priceModal"
                      @click="setOrderId(service['_id'])"
                    >
                      Set Price
                    </button>
                  </div>
                  <div class="col-md-6">
                    <button type="button" class="btn btn-success btn-sm">
                      Validate
                    </button>
                  </div>
                  <div class="col-md-6">
                    <button type="button" class="btn btn-danger btn-sm">
                      Reject
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-footer bg-white text-muted">
                Created :
                <span class="badge badge-pill badge-success my-2">
                  {{ getDate(service["createdAt"]) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Price-->
    <div
      class="modal fade"
      id="priceModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Set Price</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- Price -->
            <div class="md-form">
              <input
                type="text"
                id="price"
                class="form-control"
                v-model="price"
              />
              <label for="price">Price</label>
            </div>
            <!-- Save button -->
            <button
              class="
                btn btn-outline-info btn-rounded btn-block
                z-depth-0
                my-4
                waves-effect
              "
              type="button"
              @click="setPrice()"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--Modal: user information-->
    <div
      class="modal fade"
      id="userInfo"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog cascading-modal modal-avatar modal-sm"
        role="document"
      >
        <!--Content-->
        <div class="modal-content">
          <!--Header-->
          <div class="modal-header">
            <img
              :src="userInfo.profile"
              alt="avatar"
              class="rounded-circle img-responsive"
            />
          </div>
          <!--Body-->
          <div class="modal-body text-center mb-1">
            <h5 class="mt-1 mb-2 text-primary">{{ fullName }}</h5>

            <div>
              <span class="font-weight-bold">Email : </span
              ><span>{{ userInfo.email }}</span>
            </div>
            <div>
              <span class="font-weight-bold">SSN : </span
              ><span>{{ userInfo.id_number }}</span>
            </div>
            <div>
              <span class="font-weight-bold">Address : </span
              ><span>{{ userInfo.address }}</span>
            </div>

            <div>
              <span class="font-weight-bold">Verified : </span
              ><span v-if="userInfo.verified">Verified </span>
              <span class="text-danger" v-else>Not Verified</span>
            </div>
          </div>
        </div>
        <!--/.Content-->
      </div>
    </div>
    <!--Modal: user information-->
  </div>
</template>

<script>
import swal from "sweetalert";
const axios = require("axios");
export default {
  data() {
    return {
      services: [],
      userInfo: {
        firstname: "",
        lastname: "",
        profile: "",
        email: "",
        id_number: "",
        address: "",
      },
      price: "",
      orderId: "",
    };
  },
  sockets: {
    connect: function () {
      console.log("socket connected");
    },
    receive_job: function (data) {
      alert(data);
      console.log(data.message);
    },
  },
  methods: {
    sendJob() {
      this.$socket.emit("send_job", "hello job");
    },
    fetchData() {
      axios
        .get("http://127.0.0.1:3000/api/orders", this.options)
        .then((response) => {
          console.log("service", response.data[1].data);
          this.services = response.data[1].data;
          this.loading = false;
        })
        .catch(function (error) {
          swal("Oops", error.toString(), "error");
        });
    },
    getDate(timestamp) {
      var date = new Date(timestamp);
      return (
        date.getDate() +
        "/" +
        (date.getMonth() + 1) +
        "/" +
        date.getFullYear() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds()
      );
    },
    setUserInfo(userData) {
      console.log(userData.firstname);
      this.userInfo.firstname = userData.firstname;
      this.userInfo.lastname = userData.lastname;
      this.userInfo.profile = userData.profile;
      this.userInfo.email = userData.email;
      this.userInfo.id_number = userData.id_number;
      this.userInfo.address = userData.address;
    },
    setOrderId(id) {
      this.orderId = id;
    },
    setPrice() {
      axios
        .patch("http://127.0.0.1:3000/api/orders/" + this.orderId, [
          {
            propName: "price",
            value: this.price,
          },
        ])
        .then(() => {
          swal("Success", "Password changed successfully", "success");
        })
        .catch((err) => {
          swal("Oops", err.toString(), "error");
        });
    },
    formatPrice(price) {
      return price / 100 + " $";
    },
  },
  computed: {
    fullName() {
      if (this.userInfo.firstname && this.userInfo.lastname)
        return this.userInfo.firstname + " " + this.userInfo.lastname;
      return "";
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>